<template>
    <div id="overlay">
        <div id="text" class="border">
            <div>
                <div id="overlayHeader">
                    <h2>Copier</h2>
                </div>
                <form v-on:keyup.enter="confirm">
                    <div class="form-group row custom-control custom-radio">
                        <input type="radio" id="endOfMonth" name="radioCopy" class="custom-control-input " v-model="picked" value=1>
                        <label class="custom-control-label" for="endOfMonth"> Le reste du mois </label>
                    </div>

                    <div class="form-group row custom-control custom-radio">
                        <input type="radio" id="days" name="radioCopy" class="custom-control-input" v-model="picked" value=2>
                        <label class="custom-control-label" for="days">Jours spécifiques</label>
                        <v-date-picker 
                            id="datePicker" 
                            :mode='mode' 
                            :min-date='min'
                            v-model='selectedDate' 
                            :popover="{ placement: 'bottom', visibility: 'click' }" 
                            :first-day-of-week="2"
                            locale="fr-FR"
                        />
                    </div>
                    <span id="cancel" >
                        <b-icon v-on:click="toggleOverlay" icon="x-circle-fill"/>
                    </span>
                    <div class="form-group row">
                        <div id="validBtn">
                            <div class="btn btn-success" v-on:click="confirm">Valider</div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "EventCopyOverlay",
        props: {
            holidays: Array,
            maxDay: Number,
            copyFrom: Number,
            shift: Number,
            year: Number,
            month: Number,
            overlay: Boolean,
        },
        data() {
            return {
                mode: 'multiple',
                selectedDate: null, 
                min: new Date(this.year, this.month-1, 1),
                picked: 1,
            }
        },
        methods: {
            resetData: function() {
                this.picked = 1;
            },
            toggleOverlay: function() {
                this.$emit('cancel');
            },
            confirm: function() {
                if (this.picked == 2) {
                    if (this.selectedDate) {
                        this.selectedDate.forEach((value, index) => {
                            this.selectedDate[index] = value.getFullYear() + "-" + (value.getMonth() + 1) + "-" + value.getDate();
                        });
                    }
                } else if (this.picked == 1) {
                    this.selectedDate = [];
                    for (var day = 1; day < this.maxDay + 1; day++) {
                        if (((day + this.shift) % 7) != 0 && ((day + this.shift) % 7) != 6 && day != this.copyFrom) { // 0 is sunday and 6 is saturday
                            if(!this.holidays[day]){
                                this.selectedDate.push(this.year + "-" + this.month + "-" + day);
                            }
                        }
                    }
                }
                this.$emit('confirm', this.selectedDate);
                this.resetData();
            },
        },
        watch: {
            selectedDate: function() {
                if(this.selectedDate != null){
                    this.picked = 2;
                }
            },
            copyFrom: function(){
                document.getElementById('endOfMonth').focus();
            }
        }
    };
</script>

<style scoped>
    #overlay {
        position: fixed;
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 2;
    }

    #datePicker {
        display: inline-block;
        padding-left: 10px;
    }

    #text {
        width: 40%;
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 50px;
        color: white;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        background-color: white;
        border-radius: 25px;
    }

    .custom-control {
        display: flex;
        margin-left: auto;
        margin-right: auto;
        width: 80%;
    }

    form {
        background-color: white;
        color: black;
        font-size: 16px;
        margin: 10px;
    }

    h2 {
        background-color: white;
        color: black;   
        width: 80%;
        margin: auto;
    }

    optgroup {
        color: #ebebe4;
        background-color: #636363;
    }
    #cancel{
        position:absolute;
        top: 0px;
        right: 5px;
        color: red;
        font-size: 30px;
    }
    
    #cancel:hover{
        cursor: pointer;
    }
    #validBtn{
        margin: auto;
    }
    @media screen and (max-width: 479px){
      .border {
        width: 73% !important;
      }
      #text {
        left: 39.5%;
      }
    }
</style>